/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Card/Surcharge/Content"
  
}) {
let constantData = 'A'
let reusableMethodProviderLocationAccountCardFeePercentValueData = fromData.useDataFormat({ viewPath,
context: 'reusable_method',
path: 'provider_location_account.card_fee_percent',
format: fromFormat.percentage,
})
let constantData1 = 'fee will be added'
let aggregateData = fromAggregate.join(constantData, reusableMethodProviderLocationAccountCardFeePercentValueData, constantData1)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'A'"
 data="reusable_method.provider_location_account.card_fee_percent"
 format="/Data/format.js percentage"
 data="'fee will be added'"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}